import {FeatureTemplate} from '../../model/license/feature-template.model';
import {OrganizationData} from '../../model/organization/organization-data';
import axios from '../axios';

export namespace OrganizationController {
  export const createOrganization = async (name: string, publicKey: string) => {
    await axios.post<FeatureTemplate[]>('/internal/organization', {
      name: name,
      publicKey: publicKey
    })
  }

  export const updateActive = async (organizationId: string, active: boolean) => {
    await axios.put(`/internal/organization?organizationId=${organizationId}&active=${active}`)
  }

  export const fetchOrganizations = async () =>
    (await axios.get<OrganizationData[]>('/internal/organization')).data

  export const fetchOrganization = async (organizationId: string) =>
    (await axios.get<OrganizationData>(`/internal/organization/${organizationId}`)).data
}
